<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>资讯管理</el-breadcrumb-item>
      <el-breadcrumb-item>视光讲堂</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 列表 strat -->
      <el-tab-pane label="视光讲堂列表" name="first">
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords">
          <el-form-item label="">
            <el-input v-model="keywords.newstitle" @keyup.enter.native="clicksearch" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.istop" placeholder="请选择">
              <el-option label="请选择是否置顶" value="0"></el-option>
              <el-option label="置顶" value="1"></el-option>
              <el-option label="不置顶" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询 end -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Istops" label="是否置顶" width="100px"></el-table-column>
          <el-table-column prop="Newstitle" label="标题"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" width="200px"></el-table-column>
          <el-table-column prop="" label="操作" width="150px">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goOptometryHallModify(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="removeCase(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加视光讲堂" name="second">
        <el-form :model="addForm" ref="addFormRef" label-width="118px">
          <el-form-item label="标题" class="addAdminForm">
            <el-input v-model="addForm.newstitle" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="缩略图" class="addAdminForm">
            <TencentyunCosUploadImg :propsimageUrl="addForm.newsavatar" @change="changeTencentyunCosUploadImg"></TencentyunCosUploadImg>
          </el-form-item>
          <el-form-item label="是否置顶">
            <el-select v-model="addForm.istop" placeholder="请选择" class="select">
              <el-option label="置顶" value="1"></el-option>
              <el-option label="不置顶" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="详细内容">
            <VueUeditorWrap v-model="addForm.newsinfo" :config="myConfig"></VueUeditorWrap>
          </el-form-item>

          <el-form-item style="margin-top: 80px">
            <el-button type="primary" @click="clickAdd">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="修改" name="three" disabled="disabled">
        <OptometryHallModify ref="SubVuethree" v-on:triggerFunc="BackToFirst"></OptometryHallModify>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadImg from '@/components/TencentyunCosUploadImg.vue'
import OptometryHallModify from '@/componentsSubVue/OptometryHallModify.vue'
import VueUeditorWrap from 'vue-ueditor-wrap'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadImg,
    VueUeditorWrap,
    OptometryHallModify
  },
  name: 'MyOptometryHall',
  data () {
    return {
      activeName: 'first',
      keywords: {
        newstitle: '',
        istop: '0'
      },
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      addForm: {
        istop: '2',
        newsavatar: '',
        newstitle: '',
        newsinfo: ''
      },
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 500,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口
        serverUrl: '',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
      }
    }
  },
  mounted () {
    this.apiOptometryHallnum()
    this.apiOptometryHalllist()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    changeTencentyunCosUploadImg (url) {
      this.addForm.newsavatar = url
    },
    clickAdd () {
      this.apiAddOptometryHall()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiOptometryHallnum()
      this.apiOptometryHalllist()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiOptometryHalllist()
    },
    removeCase (row) {
      this.$confirm('是否删除此视光讲堂?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDeleteOptometryHall(row.Id)
      })
    },
    goOptometryHallModify (row) {
      this.activeName = 'three'
      this.$refs.SubVuethree.LoadData({ name: '', params: { newsid: row.Id, istop: row.Istop, newsavatar: row.Newsavatar, newstitle: row.Newstitle, newsinfo: row.Newsinfo } })
    },
    apiOptometryHalllist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        newstitle: that.keywords.newstitle,
        istop: that.keywords.istop
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_OptometryHalllist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiOptometryHallnum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        newstitle: that.keywords.newstitle,
        istop: that.keywords.istop
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_OptometryHallnum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddOptometryHall: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        istop: that.addForm.istop,
        newsavatar: that.addForm.newsavatar,
        newstitle: that.addForm.newstitle,
        newsinfo: that.addForm.newsinfo
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddOptometryHall, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiOptometryHallnum()
            that.apiOptometryHalllist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDeleteOptometryHall: function (id) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        newsid: id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteOptometryHall, Qs.stringify(data))
        .then(function (response) {
          that.apiOptometryHallnum()
          that.apiOptometryHalllist()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select{
    width: 322px;
}
.avatar-uploader{
    margin-right: 20px;
}
/deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
/deep/ .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.upload{
    display: flex;
    padding-top: 15px;
    align-items: center;
}
.quill-editor{
    height: 300px;
}

/deep/ .el-form-item__content {
    line-height: 20px;
}
</style>
